export default [
  {
    path: '/elaboracao/manter',
    name: 'manterElaboracao',
    component: () => import(/* webpackChunkName: "elaboracao-manter" */ './manterElaboracao.vue'),
    children: [
      {
        path: '/elaboracao/manter/filtroDestinatarios',
        name: 'filtroDestinatarios',
        components: {
          interessadoRouter: () => import(/* webpackChunkName: "elaboracao-manter" */ '@/components/filtro-interessados/protocolo')
        }
      },
      {
        path: '/elaboracao/manter/consultarContatoExterno',
        name: 'consultarContatoExterno',
        components: {
          interessadoRouter: () => import(/* webpackChunkName: "elaboracao-manter" */ '@/components/manter-processo/contatoExterno/consultar/ConsultarContatoExterno')
        }
      },
      {
        path: '/elaboracao/manter/manterContatoExterno',
        name: 'manterContatoExterno',
        components: {
          interessadoRouter: () => import(/* webpackChunkName: "elaboracao-manter" */ '@/components/manter-processo/contatoExterno/manter/ManterContatoExterno')
        }
      }
    ]
  }
]
